export default __webpack_public_path__ + "static/media/SECONDARY-COLORS.deee99f9.png";